// extracted by mini-css-extract-plugin
module.exports = {"BreadCrumbs":"BreadCrumbs_BreadCrumbs__3x7Oo","BreadCrumbsItem":"BreadCrumbs_BreadCrumbsItem__1P8A0","BreadCrumbsItem_anchor":"BreadCrumbs_BreadCrumbsItem_anchor__3Xc1b"};